import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  id: "components-layout-demo-basic",
  class: "index"
};
const _hoisted_2 = {
  class: "login-div"
};
const _hoisted_3 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_layout_header = _resolveComponent("a-layout-header");
  const _component_a_input = _resolveComponent("a-input");
  const _component_a_form_item = _resolveComponent("a-form-item");
  const _component_a_input_password = _resolveComponent("a-input-password");
  const _component_a_button = _resolveComponent("a-button");
  const _component_a_form = _resolveComponent("a-form");
  const _component_a_card = _resolveComponent("a-card");
  const _component_a_layout_content = _resolveComponent("a-layout-content");
  const _component_a_layout_footer = _resolveComponent("a-layout-footer");
  const _component_a_layout = _resolveComponent("a-layout");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_layout, null, {
    default: _withCtx(() => [_createVNode(_component_a_layout_header), _createVNode(_component_a_layout_content, null, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_card, {
        title: _ctx.$t('forget_pass_title')
      }, {
        extra: _withCtx(() => [_createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = (...args) => $options.goToLogin && $options.goToLogin(...args))
        }, _toDisplayString(_ctx.$t('login')), 1)]),
        default: _withCtx(() => [_createVNode(_component_a_form, {
          model: $data.form,
          "label-col": $data.labelCol,
          "wrapper-col": $data.wrapperCol,
          rules: _ctx.rules
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            label: _ctx.$t('phone_email'),
            name: "account"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: $data.form.account,
              "onUpdate:value": _cache[1] || (_cache[1] = $event => $data.form.account = $event),
              placeholder: _ctx.$t('ph_phone_email')
            }, null, 8, ["value", "placeholder"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_a_form_item, {
            label: _ctx.$t('ver_code'),
            name: "code"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: $data.form.code,
              "onUpdate:value": _cache[2] || (_cache[2] = $event => $data.form.code = $event),
              placeholder: _ctx.$t('ph_ver_code'),
              style: {
                "width": "146px"
              }
            }, null, 8, ["value", "placeholder"]), _withDirectives(_createElementVNode("input", {
              type: "button",
              class: "getNumber",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.codeMsg = $event),
              onClick: _cache[4] || (_cache[4] = (...args) => $options.getCode && $options.getCode(...args)),
              disabled: $data.codeDisabled
            }, null, 8, _hoisted_3), [[_vModelText, $data.codeMsg]])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_a_form_item, {
            label: _ctx.$t('new_pass'),
            name: "password"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input_password, {
              value: $data.form.password,
              "onUpdate:value": _cache[5] || (_cache[5] = $event => $data.form.password = $event),
              placeholder: _ctx.$t('ph_new_pass'),
              autocomplete: "off"
            }, null, 8, ["value", "placeholder"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_a_button, {
            type: "primary",
            onClick: $options.save,
            onKeyup: _withKeys($options.save, ["enter"]),
            block: ""
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('complete')), 1)]),
            _: 1
          }, 8, ["onClick", "onKeyup"])]),
          _: 1
        }, 8, ["model", "label-col", "wrapper-col", "rules"])]),
        _: 1
      }, 8, ["title"])])]),
      _: 1
    }), _createVNode(_component_a_layout_footer, null, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('copyright')), 1)]),
      _: 1
    })]),
    _: 1
  })]);
}